/**
 * Safe accessor for the logged-in user stored in localStorage under "sixers_user".
 * Never throws — returns {} if storage is empty or the value is malformed JSON.
 */
export function getSessionUser() {
  try {
    const raw = localStorage.getItem("sixers_user");
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}
